const whatsappUrl = "https://wa.me/11937354692?text=Ol%C3%A1%2C%20tenho%20interesse%20na%20Vynora%20Pisos";

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {/* CTA Final Section */}
      <section className="relative overflow-hidden" style={{ height: "360px" }}>
        <img
          src="https://readdy.ai/api/search-image?query=luxurious%20modern%20living%20room%20with%20premium%20vinyl%20wood%20flooring%2C%20elegant%20furniture%2C%20warm%20golden%20hour%20lighting%2C%20large%20windows%2C%20sophisticated%20Brazilian%20apartment%20interior%2C%20ultra%20realistic%20photography&width=1920&height=700&seq=ctafinal001&orientation=landscape"
          alt="Transforme seu ambiente"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/55 to-black/70 md:bg-gradient-to-r md:from-black/75 md:via-black/55 md:to-black/30" />
        <div className="relative z-10 h-full flex flex-col justify-center items-center text-center md:items-start md:text-left max-w-7xl mx-auto px-5 md:px-10">
          <p className="text-amber-400 text-xs font-bold tracking-widest uppercase mb-3">
            Pronto para transformar?
          </p>
          <h2
            className="text-2xl sm:text-3xl md:text-6xl font-bold text-white mb-4 max-w-2xl leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Pronto para transformar
            <br />
            seu ambiente?
          </h2>
          <p className="text-white/70 text-sm md:text-lg mb-6 max-w-lg">
            Solicite um orçamento sem compromisso e descubra como valorizar seu
            espaço com o melhor piso vinílico.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-amber-700 hover:bg-amber-600 text-white font-semibold text-sm px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-base" />
              Quero transformar meu ambiente
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-pulse-light inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/40 text-white font-semibold text-sm px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              <i className="ri-whatsapp-line text-base text-green-400" />
              Fale no WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        id="orcamento"
        style={{ backgroundColor: "#1c1814" }}
        className="text-stone-300"
      >
        {/* Main grid */}
        <div className="max-w-7xl mx-auto px-5 md:px-10 pt-12 md:pt-16 pb-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 mb-10">

            {/* Brand — spans 2 cols on lg */}
            <div className="sm:col-span-2 lg:col-span-2">
              <img
                src="https://static.readdy.ai/image/502d463b4dcc72d8a201e6614063914b/a04a76a30e2bb0445f0f57c7d79a766e.png"
                alt="Vynora Pisos"
                className="h-20 w-auto object-contain mb-4"
              />
              <p
                className="text-stone-400 text-xs leading-relaxed tracking-wide uppercase mb-6"
                style={{ letterSpacing: "0.12em" }}
              >
                Transformamos ambientes.
                <br />
                Valorizamos{" "}
                <span className="text-amber-500 font-semibold">detalhes.</span>
              </p>

            </div>

            {/* Institucional */}
            <div>
              <p className="text-amber-500 font-bold text-xs mb-5 uppercase tracking-widest">
                Institucional
              </p>
              <ul className="flex flex-col gap-3">
                {[
                  { label: "Sobre nós", id: "sobre" },
                  { label: "Nossos produtos", id: "galeria" },
                  { label: "Diferenciais", id: "beneficios" },
                  { label: "Contato", id: "orcamento" },
                ].map((item) => (
                  <li key={item.id}>
                    <button
                      onClick={() => scrollTo(item.id)}
                      className="text-stone-400 hover:text-amber-400 text-xs transition-colors cursor-pointer"
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Produtos */}
            <div>
              <p className="text-amber-500 font-bold text-xs mb-5 uppercase tracking-widest">
                Produtos
              </p>
              <ul className="flex flex-col gap-3">
                {[
                  "Pisos Vinílicos",
                  "Rodapés",
                  "Acessórios",
                  "Cuidados e Manutenção",
                ].map((s) => (
                  <li key={s}>
                    <span className="text-stone-400 text-xs">{s}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Atendimento */}
            <div>
              <p className="text-amber-500 font-bold text-xs mb-5 uppercase tracking-widest">
                Atendimento
              </p>
              <ul className="flex flex-col gap-4">
                <li className="flex items-start gap-2.5">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-phone-line text-amber-500 text-sm" />
                  </div>
                  <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-stone-300 text-xs hover:text-amber-400 transition-colors cursor-pointer"
                  >
                    (11) 93735-4692
                  </a>
                </li>
                <li className="flex items-start gap-2.5">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-mail-line text-amber-500 text-sm" />
                  </div>
                  <a
                    href="mailto:VynoraBrasil@outlook.com"
                    className="text-stone-300 text-xs hover:text-amber-400 transition-colors cursor-pointer"
                  >
                    VynoraBrasil@outlook.com
                  </a>
                </li>
                <li className="flex items-start gap-2.5">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-time-line text-amber-500 text-sm" />
                  </div>
                  <div>
                    <p className="text-stone-300 text-xs">Seg – Sex: 08h às 18h</p>
                    <p className="text-stone-400 text-xs">Sáb: 08h às 12h</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-stone-700/60 pt-6">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              {/* Address */}
              <div className="flex items-start gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-amber-500 text-sm" />
                </div>
                <p className="text-stone-500 text-xs leading-relaxed">
                  Rua das Acácias, 123 – Bairro Nobre
                  <br />
                  São Paulo – SP | CEP 01234-567
                </p>
              </div>

              {/* Tagline */}
              <p className="text-stone-500 text-xs text-center hidden md:block">
                <i className="ri-heart-fill text-amber-600 mr-1" />
                Feito para transformar o que mais importa: o seu espaço.
              </p>

              {/* Copyright */}
              <p className="text-stone-600 text-xs whitespace-nowrap">
                © 2024 Vynora Pisos. Todos os direitos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}